export default "__VITE_ASSET__dd115ac2__"